import { render, staticRenderFns } from "./IconCopy.vue?vue&type=template&id=48af533b&"
import script from "./IconCopy.vue?vue&type=script&lang=js&"
export * from "./IconCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48af533b')) {
      api.createRecord('48af533b', component.options)
    } else {
      api.reload('48af533b', component.options)
    }
    module.hot.accept("./IconCopy.vue?vue&type=template&id=48af533b&", function () {
      api.rerender('48af533b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCopy.vue"
export default component.exports